<template>
  <router-view />
</template>

<script setup>
// Root layout component that renders router views
// This allows the app to switch between different pages (Home gallery and Theme Editor)
</script>
